/*
 * Open the header dropdowns on hover.
 *
 * Dawn builds the nav out of <details>/<summary>, so it is click-to-open by
 * design and keyboard-accessible for free. This layers hover on top without
 * taking either of those away:
 *
 *   - hover only where a real pointer exists, so touch keeps tap-to-open;
 *   - a short close delay, because the pointer has to cross the sliver
 *     between the label and the panel and would otherwise slam it shut;
 *   - clicking a label that hover already opened follows the parent link
 *     instead of toggling the panel closed, which is what it looks like it
 *     should do. The URL comes from data-href on the summary.
 *
 * Setting `open` fires the native toggle event, so DetailsDisclosure and
 * HeaderMenu in details-disclosure.js keep doing their own bookkeeping
 * (focus-out closing, and pinning the sticky header open).
 */
(function () {
  const FINE_POINTER = window.matchMedia('(hover: hover) and (pointer: fine)');
  const CLOSE_DELAY = 150;

  function init() {
    const menus = document.querySelectorAll('.header__inline-menu header-menu');
    menus.forEach(function (menu) {
      const details = menu.querySelector('details');
      const summary = details && details.querySelector('summary');
      if (!details || !summary) return;

      let closeTimer = null;

      function open() {
        clearTimeout(closeTimer);
        menus.forEach(function (other) {
          if (other !== menu) close(other.querySelector('details'));
        });
        if (details.open) return;
        details.open = true;
        summary.setAttribute('aria-expanded', 'true');
      }

      menu.addEventListener('mouseenter', function () {
        if (FINE_POINTER.matches) open();
      });

      menu.addEventListener('mouseleave', function () {
        if (!FINE_POINTER.matches) return;
        clearTimeout(closeTimer);
        closeTimer = setTimeout(function () {
          close(details);
        }, CLOSE_DELAY);
      });

      summary.addEventListener('click', function (event) {
        if (!FINE_POINTER.matches) return;
        const href = summary.dataset.href;
        if (!details.open || !href || href === '#') return;
        event.preventDefault();
        window.location.href = href;
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      document
        .querySelectorAll('.header__inline-menu header-menu details[open]')
        .forEach(close);
    });
  }

  function close(details) {
    if (!details || !details.open) return;
    details.open = false;
    const summary = details.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', 'false');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
